import React from 'react';
import { ServiceIcon } from './icons';

// 중형 세단 기준가를 대표 가격으로 노출. 9차종 개편 후 'mid-sedan'이 표준 대표 ID.
function formatPrice(price) {
  if (!price || price <= 0) return '문의';
  return '₩' + price.toLocaleString();
}

export default function ServiceCard({ service }) {
  const svcId = service.id || service.serviceId;
  const repPrice = service.prices?.['mid-sedan'];
  return (
    <div className="card service-card">
      <span className="service-card-icon" style={{ display: 'inline-flex', color: 'var(--primary)' }}>
        <ServiceIcon serviceId={svcId} fallbackIcon={service.icon} size={44} />
      </span>
      <h3 className="service-card-name">
        {service.name}
      </h3>
      <p className="service-card-desc">
        {service.description}
      </p>
      <p className="service-card-price">
        {formatPrice(repPrice)}~
      </p>
      <p style={{ color: 'var(--text-dim)', fontSize: '0.75rem', marginTop: 2 }}>
        중형 기준
      </p>
    </div>
  );
}
